import { render, staticRenderFns } from "./SubmenuRoot.vue?vue&type=template&id=07c5c6a3&scoped=true&"
import script from "./SubmenuRoot.vue?vue&type=script&lang=js&"
export * from "./SubmenuRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c5c6a3",
  null
  
)

export default component.exports